export default __webpack_public_path__ + "static/media/bg-campaign-1.157afb58.png";